import MapComponent from "./MapComponent";

const ContactUs = () => {

    return (
        <section id="contact_us" className="p-5 bg-transparent text-center text-light">
            <div className="container">
                <h1 className="font-link fw-bold pb-5 pt-5">راه های ارتباطی</h1>

                <div className="row d-flex align-items-center text-center">

                    <div className="col-md-6 text-center">

                        <h5 className="font-link text-center fw-bolder pb-5">
                            دفتر مرکزی : شیراز، خیابان زند، خیابان شهید عباییان، ساختمان دی
                        </h5>
                        <h5 className="font-link fw-bolder text-center pb-5">تلفن : 07132308943 - 09350619551</h5>
                        <h5 className="font-link fw-bolder text-center pb-5">
                            ایمیل : support@faraad.org
                        </h5>
                    </div>
                    <div className='custom-size text-center'>
                        <MapComponent/>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactUs;